import { getElementsById } from "core-integration/src/store/elements/reducers";
import { SubStatus } from "core-integration/src/store/my-team/types";
import { size } from "polished";
import * as React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import Remove from "../../img/icons/remove.svg?react";
import ElementDialogButton from "../ElementDialogButton";
import ElementShirt from "../ElementShirt";
import ElementValueBar from "../ElementValueBar";
import {
  Controls,
  InfoControl,
  PitchElementWrap,
  PrimaryControl,
  StyledPitchElement,
} from "../Pitch";
import PitchElementData from "../PitchElementData";
import PlaceholderShirt from "../PlaceholderShirt";
import { UnstyledButton } from "../Utils";

const StyledRemove = styled(Remove)`
  ${size(14)}
  display: block;
  fill: #e9ff03;
  color: #e50012;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(16)}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    ${size(20)}
  }
`;

interface IOwnProps {
  actionMe: () => void;
  elementId: number;
  elementValue: React.ReactNode;
  renderElementMenu: () => void;
  variant?: SubStatus;
}

interface IStyleProps {
  isRemoved?: boolean;
}
type Props = IOwnProps & IStyleProps;

const SquadPitchElement = ({
  actionMe,
  elementId,
  elementValue,
  isRemoved,
  renderElementMenu,
  variant,
}: Props) => {
  const elementsById = useSelector(getElementsById);
  const element = elementsById[elementId];
  const shirtProps = {
    hasShadow: true,
    sizes: "(min-width: 1024px) 55px, (min-width: 610px) 44px, 33px",
  };

  return (
    <PitchElementWrap variant={variant}>
      <StyledPitchElement isRemoved={isRemoved}>
        <UnstyledButton type="button" onClick={renderElementMenu}>
          {isRemoved ? (
            <PlaceholderShirt
              elementType={element.element_type}
              {...shirtProps}
            />
          ) : (
            <ElementShirt {...shirtProps} elementId={element.id} />
          )}
          <ElementValueBar variant="default">
            <PitchElementData element={element} value={elementValue} />
          </ElementValueBar>
        </UnstyledButton>
        <Controls>
          <PrimaryControl>
            <UnstyledButton type="button" onClick={actionMe}>
              <StyledRemove />
            </UnstyledButton>
          </PrimaryControl>
          <InfoControl>
            <ElementDialogButton elementId={element.id} />
          </InfoControl>
        </Controls>
      </StyledPitchElement>
    </PitchElementWrap>
  );
};

export default SquadPitchElement;
